import React from 'react';
import { DownloadIcon, TrashIcon } from 'react-line-awesome';
import { useStyletron } from 'baseui';
import { Checkbox } from 'baseui/checkbox';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'baseui/modal';
import { Button, ButtonRow, FileIcon } from '@gtintel/platform-atoms';
import { downloadURL } from '@gtintel/platform-utils';
const Document = ({
  document,
  checked,
  setChecked,
  removeDocument
}) => {
  const [css] = useStyletron();
  const [showModal, setShowModal] = React.useState(false);
  const [isDeleting, setIsDeleting] = React.useState(false);
  const addToChecked = () => {
    if (checked.includes(document)) {
      setChecked(checked.filter(doc => doc.id !== document.id));
    } else {
      setChecked([...checked, document]);
    }
  };
  return <React.Fragment>
      <div className={css({
      alignItems: 'center',
      background: checked.includes(document) ? 'rgba(255, 186, 0, 0.05)' : 'transparent',
      border: '1px solid #eee',
      borderColor: checked.includes(document) ? 'rgba(255, 186, 0, 0.5)' : 'transparent',
      borderRadius: '4px',
      cursor: 'pointer',
      display: 'flex',
      flexFlow: 'column',
      gap: '20px',
      justifyContent: 'space-between',
      padding: '16px',
      position: 'relative',
      transition: 'all 0.2s ease',
      ':hover': {
        borderColor: '#e1e1e1'
      }
    })}>
        <div className={css({
        display: 'flex',
        flexFlow: 'row nowrap',
        justifyContent: 'space-between',
        position: 'absolute',
        top: '8px',
        right: '8px',
        width: 'calc(100% - 16px)'
      })}>
          <Checkbox checked={checked.includes(document)} onChange={addToChecked} />

          <div className={css({
          display: 'flex',
          gap: '4px'
        })}>
            {removeDocument && <Button size="mini" kind="secondary" onClick={() => removeDocument(document.id, 'document')} testId="remove-document-button">
                <TrashIcon />
              </Button>}

            <Button size="mini" kind="secondary" onClick={() => downloadURL(document.url.toString(), document.filename)}>
              <DownloadIcon />
            </Button>
          </div>
        </div>

        <FileIcon extension={document.filename.split('.').pop().toLowerCase()} />
        <div className={css({
        alignItems: 'center',
        display: 'flex',
        flexFlow: 'column nowrap',
        justifySelf: 'flex-start',
        width: '100%'
      })}>
          <p className={css({
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 2,
          margin: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          textAlign: 'center',
          width: '100%'
        })} title={document.filename}>
            {document.filename}
          </p>
          <small>{document.size}</small>
        </div>
      </div>

      <Modal isOpen={showModal} onClose={() => setShowModal(false)} animate autoFocus size="xlarge" overrides={{
      Root: {
        style: {
          zIndex: 2
        }
      }
    }}>
        <ModalHeader>Delete File</ModalHeader>
        <ModalBody>
          <p>
            Are you sure you want to delete <b>{document.filename}</b>?
          </p>
        </ModalBody>
        <ModalFooter>
          <ButtonRow flexPosition="flex-end">
            <Button kind="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
            {removeDocument && <Button kind="primary" loading={isDeleting} disabled={isDeleting} onClick={async () => {
            setIsDeleting(true);
            await removeDocument(document.id, 'document');
            setIsDeleting(false);
            setShowModal(false);
          }}>
                Delete
              </Button>}
          </ButtonRow>
        </ModalFooter>
      </Modal>
    </React.Fragment>;
};
export default Document;